import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ jobId }) =>
    present(
      repository
        .cancelChatJob(jobId)
        .then(() => ({ jobId }))
        .catch((error) => Promise.reject({ jobId, error })),
    );
}

export type { Interactor };

export { createInteractor };
